import { render, staticRenderFns } from "./roomStatusList.vue?vue&type=template&id=16c052a2&scoped=true"
import script from "./roomStatusList.vue?vue&type=script&lang=js"
export * from "./roomStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c052a2",
  null
  
)

export default component.exports